import { FETCH_DAYTODAY_PILLS_DATA, FETCH_DAYTODAY_PILLS_DATA_DONE, FETCH_PILLS_DATA, FETCH_PILLS_DATA_DONE, FETCH_PILLS_DATA_ERR, FETCH_PILLS_DATA_CAREGIVER, SET_EVERYDAY_PILLS_DATA, RESET_PILL_ERROR, ADD_PILL, ADDING_PILLS_DONE, ADDING_PILLS_DONE_FRE, ADDING_PILLS_ERR, MOVE_PILL, REMOVE_PILL, REMOVING_PILLS_DONE, REMOVING_PILLS_ERR, SAVE_CONFIG, SAVE_CONFIG_DONE, SAVE_CONFIG_ERR, RECONNECT_HERO_DONE, SET_PILL_REFILL_STATE } from './actionTypes';
export const getDayToDayPillsData = (data) => ({
    type: FETCH_DAYTODAY_PILLS_DATA,
    data
});
export const doneFetchingDayToDayPillsData = (data) => ({
    type: FETCH_DAYTODAY_PILLS_DATA_DONE,
    data: data
});
export const getPillsData = (data) => ({
    type: FETCH_PILLS_DATA,
    data
});
export const doneFetchingPillsData = (data) => ({
    type: FETCH_PILLS_DATA_DONE,
    data: data
});
export const getPillsDataCaregiver = (data) => ({
    type: FETCH_PILLS_DATA_CAREGIVER,
    data
});
export const errorFetchingPillsData = (errorMessage) => ({
    type: FETCH_PILLS_DATA_ERR,
    errorMessage
});
export const setDayToDayPills = (data) => ({
    type: SET_EVERYDAY_PILLS_DATA,
    data
});
export const resetPillError = () => ({ type: RESET_PILL_ERROR });
export const movePill = (data) => ({
    type: MOVE_PILL,
    data
});
export const addPill = (data) => ({
    type: ADD_PILL,
    data
});
export const doneAddingPill = (data) => ({
    type: ADDING_PILLS_DONE,
    data: data
});
export const doneAddingPillFRE = (data) => ({
    type: ADDING_PILLS_DONE_FRE,
    data: data
});
export const errorAddingPill = (data) => ({
    type: ADDING_PILLS_ERR,
    errorMessage: data
});
export const removePill = (data) => ({ type: REMOVE_PILL, data });
export const doneRemovingPill = (data) => ({ type: REMOVING_PILLS_DONE, data });
export const errorRemovingPill = (data) => ({
    type: REMOVING_PILLS_ERR,
    errorMessage: data
});
export const saveConfig = () => ({ type: SAVE_CONFIG });
export const doneSavingConfig = () => ({ type: SAVE_CONFIG_DONE });
export const errorSavingConfig = (data) => ({
    type: SAVE_CONFIG_ERR,
    errorMessage: data
});
export const setPillRefillState = (data) => ({
    type: SET_PILL_REFILL_STATE,
    data
});
export const reconnectHeroDone = () => ({ type: RECONNECT_HERO_DONE });
//# sourceMappingURL=actionCreators.js.map